import NetxQueryClient, {
	type SuccessResponse,
} from '@netx/core-next/lib/queryClient';
import {getCategoryData} from '@netx/core-category/api/getCategoryData';
import {
	pollUntil,
	// getObjectIdFromProgressReport,
} from '@netx/core-next/utils/poll';
import {type ICategory} from '../schema';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `moveCategory` request params
 * (what is used to send to server)
 */
export interface MoveCategoryRequestOptions {
	movingCategoryId: number;
	toParentCategoryId: number;
	childIndex?: number;
}

/**
 * `moveCategory` request
 * (what gets sent to the server)
 */
export type MoveCategoryRequest = [
	MoveCategoryRequestOptions['movingCategoryId'],
	MoveCategoryRequestOptions['toParentCategoryId'],
	Required<MoveCategoryRequestOptions>['childIndex'],
];

/**
 * `moveCategory` response
 * (what comes back from the server)
 */
export type MoveCategoryResponse = SuccessResponse<string>; // uuid;

/**
 * `moveCategory` result
 * (what is utilized from the server response)
 */
export type MoveCategoryResult = ICategory;

export const moveCategoryEndpoint = 'moveCategory';

/**
 * Organize assets
 * @param fetchParams Fetch params
 */
export const moveCategory = async (
	{
		movingCategoryId,
		toParentCategoryId,
		childIndex = 0,
	}: MoveCategoryRequestOptions,
	signal?: AbortSignal,
) => {
	const client = NetxQueryClient();

	const requestParams: MoveCategoryRequest = [
		movingCategoryId,
		toParentCategoryId,
		childIndex,
	];

	return client
		.post<MoveCategoryResponse>(moveCategoryEndpoint, requestParams, {
			signal,
		})
		.then((response) =>
			pollUntil({uuid: response.data.result, throwOnWarnings: true}).then(
				(progressReport) =>
					getCategoryData({
						id: movingCategoryId,
					}),
			),
		);
};
export default moveCategory;
